import moment from 'moment'
import { getShortText, removeHtml } from '../functions/snippets'

class Histotry {
    constructor(dispatch, getState){
        this.dispatch = dispatch
        this.getState = getState()
        this.user = this.getState.user
        this.lines = this.getState.lines
    }

    watchTag = (id, keyTag, keyLine) => {
        const line = this.lines[keyLine]
        const tag = this.getState.tags[keyTag]
        let tagsOnLine = this.lines[keyLine].tags
        tagsOnLine = tagsOnLine ? tagsOnLine : [];

        const index = tagsOnLine.indexOf( keyTag ) != -1;
        let data =  {
            time: Date.now(),
            keyLine: keyLine,
            userId: this.user.id
        };

        data = {
            ...data,
            keyLine,
            indexLine: line.indexLine,
            keyTag,
            type: 'tag',
            status: index ? 'addTag' : 'removeTag'
        }

        return { data, dispatch: this.dispatch, id }
    }

    watchChecked = (id, keyLine) => {
        const line = this.lines[keyLine]
        let data =  {
            time: Date.now(),
            keyLine: keyLine,
            userId: this.user.id
        };

        data = {
            ...data,
            keyLine,
            indexLine: line.indexLine,
            type: 'checked',
            status: line.checked ? true : false
        }

        return { data, dispatch: this.dispatch, id }
    }

    watchDate = (id, keyLine, date) => {
        const line = this.lines[keyLine]
        const label = date.label
        let data =  {
            time: Date.now(),
            keyLine: keyLine,
            userId: this.user.id
        };

        data = {
            ...data,
            keyLine,
            indexLine: line.indexLine,
            label,
            date: date.date,
            type: 'date',
            status: date.status
        }

        return { data, dispatch: this.dispatch, id }
    }

    watchComment = (id, keyLine, comment) => {
        const line = this.lines[keyLine]
        const text = getShortText(removeHtml(comment.text), 50)
        let data =  {
            time: Date.now(),
            keyLine: keyLine,
            userId: this.user.id
        };

        data = {
            ...data,
            indexLine: line.indexLine,
            text,
            type: 'comment',
        }

        return { data, dispatch: this.dispatch, id }
    }

    watchLine = (id, keyLine) => {
        console.log(123123123213)
        const line = this.lines[keyLine]
        let data =  {
            time: Date.now(),
            keyLine: keyLine,
            userId: this.user.id
        };

        data = {
            ...data,
            indexLine: line.indexLine,
            type: 'line',
        }

        return { data, dispatch: this.dispatch, id }
    }

}

export default Histotry


// WEBPACK FOOTER //
// ./src/functions/History.js